import { Events, ToastController, NavParams, ViewController, ModalController } from 'ionic-angular';
import { Component, Input, ViewContainerRef, ViewChild, OnInit, ComponentFactoryResolver, ChangeDetectorRef, Output, EventEmitter, } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DriveServiceProvider } from '../../../providers/drive-service/drive-service';
import { StoreWrapProvider } from '../../../providers/store-wrap/store-wrap';
import { ConfigureServiceProvider } from '../../../providers/configure-service/configure-service';
import { ConfigApiServiceProvider } from '../../../providers/config-api-service/config-api-service';
import { MyGridApplicationComponent } from '../../../components/my-grid-application/my-grid-application';
@Component({
  selector: 'defaultForm',
  templateUrl: './defaultForm.html',
})
export class defaultForm implements OnInit {
  @ViewChild('defaultTemplateHolder', { read: ViewContainerRef, static: true }) defaultTemplateHolder: ViewContainerRef;
  @Input() isChildForm: any;
  @Input() field: any;
  @Input() sourceField: any;
  @Input() templateId: any;
  @Input() sourceScreen: any;
  @Input() parentForm: any;
  @Input() params: any;
  @Input() accessType: any;
  @Input() templateName: any;
  @Input() screenProps: any;
  @Input() dataAccessType: any;
  @Input() objLookupFieldValue: any;
  @Input() objLookupData: any;
  @Input() fieldDataTypes: any;
  @Input() isTemplateManager: any;
  @Input() fieldDatas: any;
  @Input() pluginData: any;
  @Input() gridParam: any;
  @Input() detailCompParams: any;
  @Input() headerFormFields: any;

  @Output() setInputProperty: EventEmitter<any> = new EventEmitter<any>();
  @Output() delete_field: EventEmitter<any> = new EventEmitter<any>();
  @Output() save_field: EventEmitter<any> = new EventEmitter<any>();
  @Output() change_type: EventEmitter<any> = new EventEmitter<any>();
  @Output() add_value: EventEmitter<any> = new EventEmitter<any>();
  @Output() select_value: EventEmitter<any> = new EventEmitter<any>();
  @Output() set_hidden_field: EventEmitter<any> = new EventEmitter<any>();
  @Output() loadPluginData_component: EventEmitter<any> = new EventEmitter<any>();
  @Output() display_name: EventEmitter<any> = new EventEmitter<any>();
  @Output() loopup_list: EventEmitter<any> = new EventEmitter<any>();
  @Output() remove_lookup_field: EventEmitter<any> = new EventEmitter<any>();
  @Output() default_value: EventEmitter<any> = new EventEmitter<any>();
  @Output() save_lookup: EventEmitter<any> = new EventEmitter<any>();
  @Output() sort_fields: EventEmitter<any> = new EventEmitter<any>();
  @Output() setLookup_Scripts: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel_Field: EventEmitter<any> = new EventEmitter<any>();
  public form: FormGroup;

  unsubcribe: any
  paramData: any;
  formTitle: any = '';
  formData: any = {};
  formFields: any = {};
  formLookup: any = {};
  today = new Date();
  isMultitabScreen: any = false;
  screenType: any = '';
  @Input() formLayout: any[]
  componentRef: any;
  fields: any;
  @Input() components: any;
  sourceKey: any;
  paramId: any;
  popupHeader: any;
  formAccessType: any;
  @Input() gridRowData: any;
  defaultFormvalue: any = [];

  constructor(public navParams: NavParams, private cdr: ChangeDetectorRef, public driveService: DriveServiceProvider, public storeWrap: StoreWrapProvider, public events: Events, public toastController: ToastController, public viewCtrl: ViewController, private componentFactoryResolver: ComponentFactoryResolver, public configureService: ConfigureServiceProvider, public configApiService: ConfigApiServiceProvider, public modal: ModalController) {
    let __self = this;
    if (window.innerWidth < 700) {

      setTimeout(() => {
        this.ngOnInit();
        this.ngAfterViewInit();
      }, 2000);
    }


    events.subscribe('defaultFormvalue', (status, data) => {
      if (status === true) {
        this.defaultFormvalue = data;
        this.driveService.pullSyncData(this.templateId, this.defaultFormvalue, this.driveService.objCurrentFolder, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.getFileData);
      }
    });
    events.subscribe('sendSourceKeyParam', (data) => {
      this.sourceKey = data;
    });

    events.subscribe('selectedTemplate', (data) => {
      __self.formLayout = this.validateFormLayout(data);
    });

    this.components = this.driveService.componentList;
    this.events.subscribe('tabTriggerData', (status, screenProps, params, dataAccessType, gridRowData) => {
      if (status == true) {
        this.dataAccessType = dataAccessType;
        this.screenProps = screenProps;
        this.params = params;
        this.gridRowData = gridRowData;
        if (dataAccessType === "newdata") {
          let formLayout = this.driveService.clearFormLayoutData(screenProps['formLayout'], params, this.dataAccessType);
          this.screenProps['formLayout'] = formLayout;
        }

        this.isMultitabScreen = true;
        this.loadComponent();
      }
    });

    this.events.subscribe('SelectedRowData', (param) => {
      this.gridParam = param;
    });
  }


  ngOnInit() {
    if (this.driveService.objCurrentFolder.template.length == 1 && this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id] != undefined) {
      this.sourceKey = this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey;
    } else if (this.driveService.objCurrentFolder.template.length > 1) {
      this.sourceKey = this.storeWrap.storeTemplates[this.driveService.objCurrentFolder.template[0].id].sourceKey;
    } else {
      if (this.driveService.activeSideMenu == 'Desk') {
        if (this.storeWrap.storeTemplates[this.configApiService.driveApi.deskTemplate]) {
          this.sourceKey = this.storeWrap.storeTemplates[this.configApiService.driveApi.deskTemplate].sourceKey;
        }
      }
    }
    /* * * * * * * * * *
     * Get app componets
     * * * * * * * * * */
    this.driveService.broadcastInfo({ src: 'defaultProps', event: 'pullAppComponents', status: true });

    /* * * * * * * * * *
     * child form navparams
     * * * * * * * * * */
    if (this.navParams.get('chilFormParams')) {
      let chilFormParams = this.navParams.get('chilFormParams');
      this.field = chilFormParams['field'];
      this.isChildForm = chilFormParams['isChildForm'];
      this.screenProps = chilFormParams['screenProps'];
      this.screenType = chilFormParams['screenType'];
      this.parentForm = chilFormParams['parentForm'];
      this.sourceField = chilFormParams['sourceField'];
      this.sourceScreen = chilFormParams['sourceScreen'];
      this.templateId = chilFormParams['templateId'];
      this.popupHeader = chilFormParams['screenName']
      this.params = chilFormParams['params'];
      this.formAccessType = chilFormParams['formAccessType'];
    }

    this.paramData = this.params;
    if (this.screenProps != undefined) {

      if (!this.templateId) {
        if (this.dataAccessType === "newdata") {
        }

        this.formLayout = this.screenProps['formLayout'];
        this.form = new FormGroup({
          fields: new FormControl(JSON.stringify(this.formLayout))
        })

        this.unsubcribe = this.form.valueChanges.subscribe((update) => {
          this.formLayout = this.validateFormLayout(JSON.parse(update.fields));
        });
      }
    } else {
      this.screenProps = {};
      this.screenProps['formLayout'] = [[{ "fields": [], "Id": "", "layoutName": "", "isVisibleHeader": "NO", "props": "" }]];
    }
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    if (this.screenProps != "") {
      this.loadComponent();
    } else if (this.isChildForm) {
      this.fetchPopupProperties();
    }
    this.cdr.detectChanges();
  }

  getComponent(name) {
    for (let i = 0; i < this.components.length; i++) {
      let item = this.components[i];
      if (item.compName === name) {
        return item;
      }
    };
    return null;
  }

  /* * * * * * *
  * fetch popup screen properties
  * * * * * * */
  fetchPopupProperties() {
    if (this.templateId && this.isChildForm) {
      this.driveService.fetchScreenProperties({}, this.templateId, (screenProps, gridRowData = null) => {
        this.screenProps = screenProps;
        this.screenProps.formLayout[0][0].layoutName = screenProps.templateName;
        this.gridRowData = gridRowData;
        this.formLayout = this.screenProps['formLayout'];
        this.form = new FormGroup({
          fields: new FormControl(JSON.stringify(this.formLayout))
        })

        this.unsubcribe = this.form.valueChanges.subscribe((update) => {
          this.formLayout = this.validateFormLayout(JSON.parse(update.fields));
        });
        this.loadComponent()
      })
    }
  }

  /* * * * * * *
  * Default Component
  * * * * * * */
  loadComponent() {
    let component: any = this.getComponent(this.screenProps.id + '-customForm');
    if (!component) {
      if (this.screenType === 'popup') {
        component = this.getComponent('defaultPopup');
      } else {
        component = this.getComponent('default');
      }
    }
    if (this.isChildForm) {
      if (this.screenType === 'popup') {
        component = this.getComponent('defaultPopup');
      } else {
        component = this.getComponent('default');
      }
    }

    if (this.isTemplateManager) {
      component = this.getComponent('default');
    }
    if (this.defaultTemplateHolder != undefined) {
      this.defaultTemplateHolder.clear();
    }
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component['comp']);
    this.componentRef = this.defaultTemplateHolder.createComponent(componentFactory);
    this.componentRef.instance.formLayout = this.screenProps.formLayout;
    this.componentRef.instance.form = this.assignFormFields();
    this.componentRef.instance.params = this.params;
    this.componentRef.instance.gridRowData = this.gridRowData;
    this.componentRef.instance.formFields = this.getFormFieldsData();
    this.componentRef.instance.onSubmit = this.saveFormData.bind(this);
    this.componentRef.instance.isTemplateManager = this.isTemplateManager;
    this.componentRef.instance.fieldDatas = this.fieldDatas;
    this.componentRef.instance.gridParam = this.gridParam;
    this.componentRef.instance.detailCompParams = this.detailCompParams;
    this.componentRef.instance.headerFormFields = this.headerFormFields;
    this.componentRef.instance.screenProps = this.screenProps;
    this.componentRef.instance.pluginData = this.pluginData;
    this.componentRef.instance.popupHeader = this.popupHeader;
    this.componentRef.instance.formAccessType = this.formAccessType;
    this.componentRef.instance.fieldDataTypes = this.fieldDataTypes;
    this.componentRef.instance.components = this.components;

    if (!this.isTemplateManager) {
      if (this.driveService.objCurrentParentFolder) {
        if (this.driveService.objCurrentParentFolder.hasOwnProperty('IsReadOnlyShare') == true && this.driveService.objCurrentParentFolder.IsReadOnlyShare == "YES") {
          this.componentRef.instance.actionDisable = true;
        }
      }
    } else if (this.isTemplateManager) {
      this.componentRef.instance.actionDisable = true;
    }

    this.componentRef.instance.change_type = this.changeType.bind(this);
    this.componentRef.instance.add_value = this.addValue.bind(this);
    this.componentRef.instance.display_name = this.displayName.bind(this);
    this.componentRef.instance.default_value = this.defaultvalue.bind(this);
    this.componentRef.instance.select_value = this.selectValue.bind(this);
    this.componentRef.instance.set_hidden_field = this.setHiddenField.bind(this);
    this.componentRef.instance.loadPluginData_component = this.loadPluginData.bind(this);
    this.componentRef.instance.save_lookup = this.saveLookup.bind(this);
    this.componentRef.instance.save_field = this.saveField.bind(this);
    this.componentRef.instance.delete_field = this.deleteField.bind(this);
    this.componentRef.instance.headerdata = this.driveService.headerDetail;
    this.componentRef.instance.loopup_list = this.loopupList.bind(this);
    this.componentRef.instance.remove_lookup_field = this.removeLookupField.bind(this);
    this.componentRef.instance.setInputProperty = this.setInputProperties.bind(this);
    this.componentRef.instance.sort_fields = this.sortFields.bind(this);
    this.componentRef.instance.setLookup_Scripts = this.setLookupScripts.bind(this);
    this.componentRef.instance.cancel_Field = this.cancelField.bind(this);

    this.componentRef.instance.obj_lookup_fieldValue = this.objLookupFieldValue;
    this.componentRef.instance.obj_lookupData = this.objLookupData;
  }

  getFormLayout() {
    this.formLayout = this.screenProps.formLayout;
    if (!this.formLayout) {
      this.formLayout = [[{ "fields": [], "Id": "", "layoutName": "", "isVisibleHeader": "NO", "props": "" }]];
    }
    return this.formLayout;
  }

  validateFormLayout(formLayout) {
    let rowIdx = 0;
    let colIdx = 0;
    let fldIdx = 0;
    formLayout.forEach(cols => {
      cols.forEach(rows => {
        rows.fields.forEach(field => {
          if (field.FieldDataType === "DATE") {
            if (field.DefaultValue === "") {
              formLayout[colIdx][rowIdx].fields[fldIdx].DefaultValue = new Date();
            }
          }
          fldIdx = fldIdx + 1;
        });
        rowIdx = rowIdx + 1;
      });
      colIdx = colIdx + 1;
    });
    return formLayout;
  }

  handleChildFrom(childFormData) {
    if (childFormData[this.sourceField] != undefined) {
      if (this.field.FieldDataType === "INLINE-EDIT") {
        this.parentForm.controls[this.field.FieldName].setValue(childFormData[this.sourceField]);
        this.viewCtrl.dismiss();
      }
      else if (this.field.FieldDataType === "DYNAMIC-LOOKUP") {
        let pushParams = this.screenProps.pushParams;
        var objData = Object.assign({}, pushParams, childFormData);

        this.configApiService.pushRequest(objData, (data) => {
          let templateProperty = this.screenProps;
          var lookupkey = data[templateProperty.id][templateProperty["sourceKey"]];
          let option = { key: lookupkey, label: childFormData[this.sourceField] }
          this.field.options.push(option);
          this.field.value = childFormData[this.sourceField];
          if (this.sourceScreen) {
            this.driveService.updateFieldPropertyLookup(this.sourceScreen);
          }
          setTimeout(() => {
            this.parentForm.controls[this.field.FieldName].setValue(lookupkey);
            this.viewCtrl.dismiss();
          }, 100);
        });
      }
    } else if (this.field.FieldDataType === "SUMMARY-LIST-ADD") {
      let pushParams = this.screenProps.pushParams;
      var objData = Object.assign({}, pushParams, childFormData);
      this.configApiService.pushRequest(objData, (data) => {
        let templateProperty = this.screenProps;
        var datakey = data[templateProperty.id];
        var obj = Object.assign({}, childFormData, datakey);
        this.events.publish('updateSummaryData', true, obj);
        this.viewCtrl.dismiss();
      });
    } else if (this.field.FieldDataType === "defaultFrom") {
      this.events.publish("footerSaveHide", true);
      let pushParams = this.screenProps.pushParams;
      childFormData[this.sourceKey] = this.params[this.sourceKey];
      var objData = Object.assign({}, pushParams, { 'userid': this.configureService.getLoginUserID() }, childFormData);
      this.configApiService.pushRequest(objData, (data) => {
        let srckey = this.screenProps.sourceKey;
        this.params[this.screenProps.sourceKey] = data[this.screenProps["id"]][srckey];
        if (this.screenProps.componentName == "SUMMARY") {
          let arrTemplateProps = [];
          this.driveService.objCurrentFolder.template.forEach(element => {
            arrTemplateProps.push(this.driveService.storeWrap.storeTemplates[element.id]);
          });
          let templateProperty = this.screenProps;
          let parentScreenParam = {};
          let versionHistroyParam = {};
          var dataScreenId = data[templateProperty["sourceKey"]]
          versionHistroyParam[templateProperty["sourceKey"]] = dataScreenId;
          parentScreenParam[this.sourceKey] = this.params[this.sourceKey];
          let pullParams = Object.assign({}, templateProperty['pullParams'], parentScreenParam);
          this.driveService.getFormGridData(pullParams, templateProperty['id'], (CurrentFilesData) => {
            this.driveService.CurrentFilesData = CurrentFilesData[0]
            // this.events.publish('triggerGridComponentLoad', true, CurrentFilesData[0]);
            this.driveService.broadcastInfo({ src: 'grid-main', event: 'triggerGridComponentLoad', status: true, rowData: CurrentFilesData[0] });

          });
        }else if (this.screenProps.componentName === 'FormGridComponent') {
          this.driveService.broadcastInfo({ src: 'form-grid', event: 'addNewRecordDefaultForm', screenProps: this.screenProps, status: true });
        }
        this.driveService.broadcastInfo({ src: 'defaultProps', event: 'passParentScreenParamOnNew', params: this.params });
        this.driveService.broadcastInfo({ src: 'defaultProps', event: 'pushParamsValue', params: this.params });
        this.events.publish('getTrackInfo', this.params);
      });
      const toast = this.toastController.create({
        message: 'Record Saved Successfully !!',
        duration: this.configApiService.toastDuration
      });
      toast.present();
      this.viewCtrl.dismiss();
    } else {
      const toast = this.toastController.create({
        message: 'Parent Field Does Not Match !!',
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  }

  responseChildScreenData = ((data) => {
    if (data.IsValid) {
      const toast = this.toastController.create({
        message: data.message,
        showCloseButton: false,
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  })

  handleMainFrom(data) {

    this.formData = data;
    let keyCheck = Object.keys(this.formData);
    if (keyCheck[0] != "") {
      this.driveService.setFormDataToDb(this.screenProps.id, this.screenProps.fieldProperties, this.formData, this.response_Data);
    }
  }

  saveFormData(data) {
    if (this.isChildForm) {
      this.handleChildFrom(data);
    } else {
      this.handleMainFrom(data);
    }
  }

  response_Data = ((data) => {
    if (data.IsValid) {
      const toast = this.toastController.create({
        message: data.message,
        showCloseButton: false,
        duration: this.configApiService.toastDuration
      });
      toast.present();
      if (data.IsValid == true) {
        // this.driveService.broadcastInfo({ src: 'sidePanelShow', event: 'sideBarShow', status: true });
        let templateProperty = this.screenProps;
        let parentScreenParam = {};
        let versionHistroyParam = {};
        var dataScreenId = data[templateProperty["sourceKey"]]
        versionHistroyParam[templateProperty["sourceKey"]] = dataScreenId;
        parentScreenParam[this.sourceKey] = this.params[this.sourceKey];
        let pullParams = Object.assign({}, templateProperty['pullParams'], parentScreenParam);
        let versionHistory_pullParams = Object.assign({}, templateProperty['pullParams'], versionHistroyParam);
        if (data.hasOwnProperty(this.sourceKey) && data[this.sourceKey] != '') {
          this.params[this.sourceKey] = data[this.sourceKey];
          this.driveService.objCurrentFolder.files = [];
          this.driveService.CurrentFilesData = [];
          this.driveService.broadcastInfo({ src: 'defaultProps', event: 'pushParamsValue', params: this.params });
          if (!this.isMultitabScreen) {
            this.driveService.getInstance().next(false)
          };
        }
        this.events.publish("footerSaveHide", true);
        /*****end*** */
        if (templateProperty.componentName === 'FormGridComponent') {
          this.driveService.getFormGridData(pullParams, templateProperty['id'], (CurrentFilesData) => {
            this.driveService.broadcastInfo({ src: 'grid-main', event: 'triggerGridComponentLoad', status: true, rowData: CurrentFilesData[0] });
            this.driveService.broadcastInfo({ src: 'form-grid', event: 'addNewRecordDefaultForm', status: true });
          })
          this.driveService.getFormGridData(versionHistory_pullParams, templateProperty['id'], (CurrentFilesData) => {
            let paramId = dataScreenId
            this.setVersionHistory(CurrentFilesData[0], paramId);
          })
        } else {
          this.componentRef.instance.actionDisable = true;
          setTimeout(() => {
            if (!this.isMultitabScreen) {
              this.driveService.broadcastInfo({ src: 'drive-main', event: 'showComponentHolder', status: false });
            }
          }, 1000)
        }
        this.driveService.broadcastInfo({ src: 'sidePanelShow', event: 'sideBarShow', status: true });
      }
    } else if (data.Result == "Failed") {
      const toast = this.toastController.create({
        message: JSON.parse(data.message).message,
        showCloseButton: true,
        duration: this.configApiService.toastDuration
      });
      toast.present();
    } else {
      const toast = this.toastController.create({
        message: data.message,
        showCloseButton: true,
        duration: this.configApiService.toastDuration
      });
      toast.present();
    }
  });

  /* * * * * *
   * Assign Form Group Fields
   * * * * * */
  assignFormFields() {
    let fieldsCtrls = {};
    if (this.screenProps.formLayout) {
      for (let formFiled of this.screenProps.formLayout) {
        for (let layout of formFiled) {
          this.fields = layout['fields'];
          if (this.fields) {
            for (let f of this.fields) {
              if (f.FieldDataType === 'checkbox') {
                let opts = {};
                for (let opt of f.options) {
                  opts[opt.key] = new FormControl(opt.value);
                }
                fieldsCtrls[f.FieldName] = new FormGroup(opts)
              }
              else if (f.FieldDataType === 'SELECT') {
                let selectedOpt;
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.label === f.DefaultValue) {
                      selectedOpt = opt.key;
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl(selectedOpt ? selectedOpt : f.DefaultValue, Validators.required);
              }
              else if (f.FieldDataType === 'DYNAMIC-LOOKUP') {
                let selectedOpt;
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.label === f.DefaultValue) {
                      selectedOpt = opt.key;
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl(selectedOpt ? selectedOpt : f.DefaultValue, Validators.required);
              }
              else if (f.FieldDataType === 'MULTISELECT_V') {
                let selectedOpt = [];
                if (f.options) {
                  for (let opt of f.options) {
                    if (opt.itemName === f.DefaultValue) {
                      if (this.dataAccessType && this.dataAccessType != "newdata") {
                        selectedOpt.push(opt);
                      }
                    }
                  }
                }
                fieldsCtrls[f.FieldName] = new FormControl(selectedOpt ? selectedOpt : [], Validators.required)
              }
              else {
                fieldsCtrls[f.FieldName] = new FormControl(f.DefaultValue, Validators.required)
              }
            }
            this.form = new FormGroup(fieldsCtrls);
          }
        }
      }
    }
    return this.form;
  }

  /* * * * * *
  * get Form data
  * * * * * */
  getFormFields() {
    if (this.screenProps.formLayout) {
      for (let formFiled of this.screenProps.formLayout) {
        for (let layout of formFiled) {
          this.fields = layout['fields'];
        }
      }
    }
    return this.fields;
  }

  /* * * * * *
  * get Form data
  * * * * * */
  getFormFieldsData() {
    if (this.screenProps.formLayout) {
      for (let formFiled of this.screenProps.formLayout) {
        for (let layout of formFiled) {
          this.fields = layout['fields'];
          if (this.fields) {
            for (let f of this.fields) {
              this.formFields[f.FieldName] = f;
            }
          }
        }
      }
    }
    return this.formFields;
  }

  setInputProperties(e) {
    this.setInputProperty.emit(e);
  }

  deleteField(data) {
    this.delete_field.emit(data);
  }

  saveField(data) {
    this.save_field.emit(data);
  }

  changeType(e) {
    this.change_type.emit(e);
  }

  addValue(e) {
    this.add_value.emit(e);
  }

  selectValue(e) {
    this.select_value.emit(e);
  }

  setHiddenField(e) {
    this.set_hidden_field.emit(e);
  }

  loadPluginData(e) {
    this.loadPluginData_component.emit(e);
  }
  displayName(e) {
    this.display_name.emit(e);
  }
  defaultvalue(e) {
    this.default_value.emit(e);
  }
  loopupList(e) {
    this.loopup_list.emit(e);
  }

  removeLookupField(e) {
    this.remove_lookup_field.emit(e)
  }

  saveLookup() {
    this.save_lookup.emit();
  }

  sortFields(e) {
    this.sort_fields.emit(e);
  }

  setLookupScripts(e) {
    this.setLookup_Scripts.emit(e);
  }

  cancelField(e) {
    this.cancel_Field.emit(e);
  }

  setVersionHistory(params, paramId) {
    this.paramId = paramId;
    let regUserId = this.configureService.getLoginUserID();
    let templateProperty = this.screenProps;
    let postdataparams = {
      Delete: "false",
      HTMLTemplate: templateProperty["id"],
      ParamId: paramId,
      ScreenData: JSON.stringify(params),
      TemplateID: templateProperty["id"],
      userid: regUserId
    }
    var objData = Object.assign({}, this.configApiService.driveApi.pushVersionHistory.params, postdataparams)
    this.configApiService.pushRequest(objData, this.submitSucess)
  }

  submitSucess = ((resData) => {
    if (resData == "SUCCESS") {
      this.driveService.broadcastInfo({ src: 'grid-main', event: 'updatedFormStatus', paramId: this.paramId, templateProperty: this.screenProps });
    }
  });

  processHistoryData(data) {
    this.driveService.updateFormProperties(data, [], this.screenProps, (responseProps) => {
      this.screenProps['formLayout'] = responseProps['formLayout'];
      this.loadComponent();
      setTimeout(() => {
        this.events.publish('loadDefaultFormVersionHistoryData', true, data);
      }, 1000)
    });
  }

  getFileData = ((data) => {
    for (var i = 0; i < data.length; i++) {
      this.driveService.broadcastInfo({ src: 'grid-main', event: 'triggerGridComponentLoad', status: true, rowData: data[i] });
    }

  });

  ngOnDestroy() {
    this.driveService.candidateFlag = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/form/defaultForm/defaultForm.component.ts